import {TripMutation} from "./types";
import {STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";

export default {
    [TripMutation.REQUEST](state) {
        state.status = STATUS_LOADING;
        state.items = [];
    },
    [TripMutation.UPDATE_REQUEST](state) {
        state.statusUpdate = STATUS_LOADING;
        state.items = [];
    },
    [TripMutation.SUCCESS](state, data) {
        state.status = STATUS_SUCCESS;
        state.items = data.items;
        state.total = data.total;
    },
    [TripMutation.SUCCESS_UPDATE](state, item) {
        state.statusUpdate = STATUS_SUCCESS;
        if(item._isVariant) {
            state.variantData = Object.assign({}, state.variantData, item);
        } else {
            state.trip = Object.assign({}, state.trip, item);
        }
    },
    [TripMutation.SUCCESS_DETAIL](state, trip) {
        state.status = STATUS_SUCCESS;
        state.trip = trip;
        state.activeVariant = trip._variants[0];
        state.variantData = null;
    },
    [TripMutation.ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
    },
    [TripMutation.ERROR_UPDATE](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
    },
    [TripMutation.SET_ACTIVE_VARIANT](state, data) {
        state.status = STATUS_SUCCESS;
        state.activeVariant = data.variant;
        state.variantData = data.trip;
    },
};
